import React, { Component } from "react";
import hyperlinks from "../../../src/util/hyperlinks";

export default class BecomeCorporateMember extends Component {
    render() {
        return (
            <div>
                <h2>How to become a corporate member of LUOW</h2>

                <p>
                    To become a Corporate Member of LUOW, your organisation will:
                </p>

                <ul>
                    <li>
                        Be approved/recommended by the LUOW Advisory Board
                    </li>
                    <li>
                        Have an overlap with the implementation of innovations and solutions in the 14 distinct <a href={hyperlinks["innovationAreas"]}>innovation areas</a> and/or your organisation works/has an interest in working with water utilities
                    </li>
                    <li>
                        Have a corporate ethos which promotes the collaborative development of the urban water sector and/or have a strong CSR programme for the betterment of the water sector
                    </li>
                    <li>
                        Be interested in learning from, and sharing knowledge and experience with, water utilities
                    </li>
                </ul>

                <p>
                    For more information, please download the Corporate Membership brochure.
                </p>

                <a href={hyperlinks["corporateMembershipBrochure"]} className="btn btn-default download-brochure">Download brochure</a>

                <p>
                    Bespoke memberships may also be organised via communication with the LUOW secretariat and consultation with the Advisory Board.
                </p>

                <p>
                    To discuss this, or any of the above, in more detail please email Abigail Smith <a href="mailto:a.smith@leadingutilities.org?Subject=Leading Utilities of the World - Corporate membership" target="_top">here</a> to continue the conversation.
                </p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/BecomeCorporateMember.jsx.erb